module.exports = __webpack_public_path__ + "img/AO.1062d8f1.svg";